import { Grid, GridProps, SystemStyleObject, useBreakpointValue } from '@chakra-ui/react';
import { InsightsItemProps, InsightsTableItem } from './InsightsTableItem';

type Props = {
  items: InsightsItemProps[];
} & GridProps;

export const InsightsTable = ({ items, ...gridProps }: Props) => {
  const itemsPerRow = items.length <= 5 ? items.length : 3;

  const styles = useBreakpointValue<SystemStyleObject>(
    {
      base: {
        '> div': {
          border: '1px',
          borderColor: 'gray.2',
          borderTop: 'none',
          borderLeft: 'none',

          ':nth-of-type(2n)': {
            borderRight: 'none',
          },
          ':nth-last-of-type(-n+2)': {
            borderTop: 'none',
            borderBottom: 'none',
          },
        },
      },
      md: {
        '> *': {
          border: '1px',
          borderLeft: '0',
          borderTop: '0',
          borderColor: 'gray.2',
        },
        [`div:nth-of-type(${itemsPerRow}n)`]: {
          borderRight: '0',
        },
        [`div:nth-last-of-type(-n+${itemsPerRow})`]: {
          borderBottom: '0',
        },
      },
    },
    'md',
  );

  /** If there are no items to show, hide the block */
  if (!items?.length) return null;

  return (
    <Grid
      bg="gray.1"
      rounded="md"
      sx={styles}
      templateColumns={{
        base: 'repeat(2, 1fr)',
        md: `repeat(${items.length <= 5 ? items.length : 3}, 1fr)`,
      }}
      {...gridProps}
    >
      {items.map((item, index) => (
        <InsightsTableItem key={`${item.value}` + index} {...item} />
      ))}
    </Grid>
  );
};
